
export class AccountType {
    private _id:           number;
    private _name:         string;

    constructor() {
        this._id           = 0;
        this._name         = "";
    }


    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }
}



// ── Bank model ────────────────────────────────────────────────────────────────
export class Bank {
    private _id:           number;
    private _name:         string;
    private _abbreviation: string;
    private _code: string;

    constructor() {
        this._id           = 0;
        this._name         = "";
        this._abbreviation = "";
        this._code = "";
    }

    get id(): number { return this._id; }
    set id(value: number) { this._id = value; }

    get name(): string { return this._name; }
    set name(value: string) { this._name = value; }

    get abbreviation(): string { return this._abbreviation; }
    set abbreviation(value: string) { this._abbreviation = value; }
    get code(): string { return this._code; }
    set code(value: string) { this._code = value; }
}

// ── BankAccount model ─────────────────────────────────────────────────────────
export class BankAccount {
    private _id:             number;
    private _bank:           Bank | null;
    private _account_number:  string;
    private _branch_code:     string;
    private _account_type:    AccountType
    private _account_holder_name: string;

    constructor() {
        this._id            = 0;
        this._bank          = null;
        this._account_number = "";
        this._branch_code    = "";
        this._account_type   = new AccountType()
        this._account_holder_name = "";
    }

    get id(): number { return this._id; }
    set id(value: number) { this._id = value; }

    get bank(): Bank | null { return this._bank; }
    set bank(value: Bank | null) { this._bank = value; }


    get account_number(): string {
        return this._account_number;
    }

    set account_number(value: string) {
        this._account_number = value;
    }

    get branch_code(): string {
        return this._branch_code;
    }

    set branch_code(value: string) {
        this._branch_code = value;
    }


    get account_type(): AccountType {
        return this._account_type;
    }

    set account_type(value: AccountType) {
        this._account_type = value;
    }

    get account_holder_name(): string {
        return this._account_holder_name;
    }

    set account_holder_name(value: string) {
        this._account_holder_name = value;
    }
}